import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d2191fc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2191fc')) {
      api.createRecord('7d2191fc', component.options)
    } else {
      api.reload('7d2191fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7d2191fc", function () {
      api.rerender('7d2191fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/menu/index.vue"
export default component.exports